export default {
  title: 'GPS Tracker設定',
  operationOffice: '運営会社',
  tripStartTime: '運行基準開始時刻',
  commonDriver: '共通ドライバー',
  messages: {
    operationOfficeRequired: '運営会社を選択してください',
  },
  list: {
      id: 'ID',
      operationOfficeName: '運営会社名',
      tripStartTime: '運行基準開始時刻',
      commonDriverName: '共通ドライバー名',
      edit: '編集',
      updatedAt: '最終更新日',
      delete: '削除',
  }
}
